import React, { useState, useEffect } from "react";
import ssoManagementService from "../../../services/SSOManagementService";
import provisionService from "../../../services/ProvisionService";
import { SiteDTO, LTIPlatformDTO } from "@beable/roster-backend-client-v1";
import { SUBPAGES } from "../constants";
import LTIPlatformForm from "../LTIPlatforms/LTIPlatformForm";
import FormModal, { ModalMessageSettings, getResultMessage } from "../../Common/FormModal";

interface EditLTIPlatformModalProps {
  open: boolean;
  handleClose: any;
  LTIPlatformItem: LTIPlatformDTO;
}

export default function EditLTIPlatformModal(props: EditLTIPlatformModalProps) {
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();
  const [isLoading, setIsLoading] = useState(false);
  const [LTIPlatform, setLTIPlatform] = useState(props.LTIPlatformItem);
  const [selectedSite, setSelectedSite] = useState<SiteDTO | null>();

  useEffect(() => {
    const fetchSiteAndSetItem = async () => {
      setIsLoading(true);
      const site = await provisionService.getSitesById(
        props.LTIPlatformItem.siteId
      );
      setSelectedSite(site);
      setLTIPlatform({
        id: props.LTIPlatformItem.id ?? SUBPAGES.LTIProviders.defaultState.id,
        name:
          props.LTIPlatformItem.name ?? SUBPAGES.LTIProviders.defaultState.name,
        environment:
          props.LTIPlatformItem.environment ??
          SUBPAGES.LTIProviders.defaultState.environment,
        issuer:
          props.LTIPlatformItem.issuer ??
          SUBPAGES.LTIProviders.defaultState.issuer,
        authRedirectUrl:
          props.LTIPlatformItem.authRedirectUrl ??
          SUBPAGES.LTIProviders.defaultState.authRedirectUrl,
        clientId:
          props.LTIPlatformItem.clientId ??
          SUBPAGES.LTIProviders.defaultState.clientId,
        deploymentId:
          props.LTIPlatformItem.deploymentId ??
          SUBPAGES.LTIProviders.defaultState.deploymentId,
        userLookupField:
          props.LTIPlatformItem.userLookupField ??
          SUBPAGES.LTIProviders.defaultState.userLookupField,
        logoutRedirectUrl:
          props.LTIPlatformItem.logoutRedirectUrl ??
          SUBPAGES.LTIProviders.defaultState.logoutRedirectUrl,
        identifierTransforms:
          props.LTIPlatformItem.identifierTransforms ??
          SUBPAGES.LTIProviders.defaultState.identifierTransforms,
        keyset:
          props.LTIPlatformItem.keyset ??
          SUBPAGES.LTIProviders.defaultState.keyset,
        keysetUrl:
          props.LTIPlatformItem.keysetUrl ??
          SUBPAGES.LTIProviders.defaultState.keysetUrl,
        siteId:
          props.LTIPlatformItem.siteId ??
          SUBPAGES.LTIProviders.defaultState.siteId,
        useStaticLaunch:
          props.LTIPlatformItem.useStaticLaunch !== undefined
            ? props.LTIPlatformItem.useStaticLaunch
            : SUBPAGES.LTIProviders.defaultState.useStaticLaunch,
        active:
          props.LTIPlatformItem.active !== undefined
            ? props.LTIPlatformItem.active
            : SUBPAGES.LTIProviders.defaultState.active,
      });
      setIsLoading(false);
    };
    fetchSiteAndSetItem();
  }, [props]);

  const submitForm = async (ltiPlatform: LTIPlatformDTO, _allEnvs: boolean) => {
    setIsLoading(true);
    const result = await ssoManagementService.updateLTIPlatform(ltiPlatform);

    const message = getResultMessage(
      result,
      `LTI platform edited successfully!`,
      `Failed to edit this LTI platform!`
    );
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title={`Edit ${props.LTIPlatformItem.name}`}
      description={`Edits the ${props.LTIPlatformItem.name} LTI platform for ${props.LTIPlatformItem.environment}.`}
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      <LTIPlatformForm
        onSubmit={submitForm}
        handleClose={handleClose}
        selectedItem={LTIPlatform}
        site={selectedSite}
      />
    </FormModal>
  );
}
